import { createContext } from 'react';
import { MediaTypeId, CheckboxesState, ContentType, ICategory, IEntity, IMedia, IPackage, IPurpose, IRules, IViewCampaign, Media } from '../interfaces/campaign';
import { IPagination } from '../interfaces/response';
import dayjs from 'dayjs';

type ContextType = {
	selectedPlatform: Media | null;
	selectedPlatformId: number | null;
	selectedContentType: ContentType | null;
	selectedMediaTypeId: MediaTypeId | string | null;
	selectedTime: number | null;
	selectedDate: dayjs.Dayjs | string | null | Date;
	typeActiveButton: number;
	categoryActiveButton: number;
	title: string;
	description: string;
	selectedCategoryId: number | null;
	selectedPurpose: CheckboxesState;
	contentStatus: number | null;
	selectedPages: IEntity[];
	selectedPackages: IPackage[];
	fetchedMedias: IMedia[] | undefined;
	fetchedCategories: ICategory[] | undefined;
	fetchedPurposes: IPurpose[] | undefined;
	fetchedEntities: IEntity[] | undefined;
	fetchedPackages: IPackage[] | any;
	fetchedEntitiesCount: number;
	fetchedCampaign: IViewCampaign | undefined;
	selectedCampaignId: string | undefined;
	loadingCampaign: boolean;
	fetchedRules: IRules | undefined;
	fetchedEntitiesPagination: IPagination | null | undefined;
	fetchedPackagesPagination: IPagination | null | undefined;
	entityPage: number;
	packagePage: number;
	viewSelectedItemsMode: boolean;
	savedCampaignId: number | null;
	IsSerialStory: boolean;
	templateImage: any[];
	sortPackages: { title: string; orderBy: string; orderByDirection: string } | null;
	setSortPackages: (val: { title: string; orderBy: string; orderByDirection: string } | null) => void;
	setTemplateImage: (templateImage: any) => void;
	setIsSerialStory: (IsSerialStory: boolean) => void;
	setSavedCampaignId: (id: number | null) => void;
	setViewSelectedItemsMode: (val: boolean) => void;
	setLoadingCampaign: (loading: boolean) => void;
	setFetchedRules: (rules: IRules) => void;
	setSelectedCampaignId: (id: string) => void;
	setFetchedPackages: (val: IPackage[] | any) => void;
	setFetchedCampaign: (campaign: IViewCampaign | undefined) => void;
	setTitle: (val: string) => void;
	setDescription: (val: string) => void;
	setSelectedCategoryId: (val: number) => void;
	setSelectedPurpose: (val: CheckboxesState) => void;
	setContentStatus: (val: number | null) => void;
	setSelectedPages: (val: IEntity[]) => void;
	setSelectedPackages: (val: IPackage[]) => void;
	setSelectedPlatform: (val: Media | null) => void;
	setSelectedPlatformId: (val: number | null) => void;
	setSelectedContentType: (val: ContentType | null) => void;
	setSelectedMediaTypeId: (val: MediaTypeId | string | null) => void;
	setSelectedTime: (val: number | null) => void;
	setSelectedDate: (val: dayjs.Dayjs | string | null | Date) => void;
	setTypeActiveButton: (index: number) => void;
	setCategoryActiveButton: (index: number) => void;
	setEntityPage: (page: number) => void;
	setPackagePage: (page: number) => void;
	setFetchedEntitiesPagination: (pagination: IPagination | null | undefined) => void;
	setFetchedEntites: (entity: IEntity[] | null | undefined) => void;
	setFetchedPackagesPagination: (pagination: IPagination | null | undefined) => void;
	setFetchedPurposes: (val: IPurpose[] | undefined) => void;
	setFetchedCategories: (val: ICategory[] | undefined) => void;
	setFetchedMedias: (val: IMedia[] | undefined) => void;
	resetAllFields: () => void;
};

export const CampaignContext = createContext<ContextType>({
	selectedPlatform: null,
	selectedPlatformId: null,
	selectedContentType: null,
	selectedMediaTypeId: null,
	selectedTime: null,
	selectedDate: dayjs(),
	typeActiveButton: 1,
	categoryActiveButton: 0,
	title: '',
	description: '',
	selectedCategoryId: null,
	selectedPurpose: {},
	contentStatus: null,
	selectedPages: [],
	selectedPackages: [],
	fetchedMedias: [],
	fetchedCategories: [],
	fetchedPurposes: [],
	fetchedEntities: [],
	fetchedPackages: [],
	fetchedEntitiesCount: 0,
	fetchedCampaign: undefined,
	selectedCampaignId: undefined,
	loadingCampaign: false,
	fetchedEntitiesPagination: null,
	fetchedPackagesPagination: null,
	viewSelectedItemsMode: false,
	entityPage: 1,
	packagePage: 1,
	savedCampaignId: null,
	fetchedRules: {
		basic: '',
		media: [],
		media_type: [],
		media_entity: [],
	},
	IsSerialStory: false,
	templateImage: [],
	sortPackages: null,
	setSortPackages: () => {},
	setIsSerialStory: () => {},
	setTemplateImage: () => {},
	setSavedCampaignId: () => {},
	setSelectedCampaignId: () => {},
	setLoadingCampaign: () => {},
	setFetchedPackages: () => {},
	setFetchedRules: () => {},
	setFetchedCampaign: () => {},
	setTitle: () => {},
	setDescription: () => {},
	setSelectedCategoryId: () => {},
	setSelectedPurpose: () => {},
	setContentStatus: () => {},
	setSelectedPages: () => {},
	setSelectedPackages: () => {},
	setSelectedPlatform: () => {},
	setSelectedPlatformId: () => {},
	setSelectedContentType: () => {},
	setSelectedMediaTypeId: () => {},
	setSelectedTime: () => {},
	setSelectedDate: () => {},
	setTypeActiveButton: () => {},
	setCategoryActiveButton: () => {},
	setEntityPage: () => {},
	setPackagePage: () => {},
	setFetchedEntitiesPagination: () => {},
	setFetchedEntites: () => {},
	setFetchedPackagesPagination: () => {},
	setFetchedPurposes: () => {},
	setFetchedCategories: () => {},
	setFetchedMedias: () => {},
	resetAllFields: () => {},
	setViewSelectedItemsMode: () => {},
});
